import type { RunVercelResult, VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { MAX_STORE_NAME_ATTEMPTS } from '@cli-constants/limits.js'
import { PROVISION_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { runVercel } from '../runner/run-vercel.js'
import { candidateStoreName } from './candidate-store-name.js'
import { isNameTaken } from './is-name-taken.js'

/**
 * `--access public` matches how uploads are served (direct public URLs) and `--yes` connects the
 * store to every environment of the linked project, which is what injects BLOB_READ_WRITE_TOKEN
 * for the env pull.
 */
export async function createStoreQuiet(
  runner: VercelRunner,
  cwd: string,
  baseName: string,
  env?: NodeJS.ProcessEnv
): Promise<{ result: RunVercelResult; storeName: string }> {
  let result: RunVercelResult | undefined
  let storeName = baseName

  for (let attempt = 1; attempt <= MAX_STORE_NAME_ATTEMPTS; attempt++) {
    storeName = candidateStoreName(baseName, attempt)
    result = await runVercel(
      runner,
      ['blob', 'create-store', storeName, '--access', 'public', '--yes'],
      { cwd, mode: 'capture', timeoutMs: PROVISION_TIMEOUT_MS, env }
    )
    if (result.success || !isNameTaken(result)) break
  }

  return { result: result as RunVercelResult, storeName }
}
